import React from "react";

interface FeatureCardProps {
  icon: string;
  iconAlt: string;
  title: string;
  description: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  icon,
  iconAlt,
  title,
  description,
}) => {
  return (
    <div className="inline-flex items-start justify-between flex-grow basis-0 rounded-lg py-4 px-2 bg-gray-100 text-black animate-fadeIn min-w-[16.2vw]">
      <div className="flex items-center align-middle justify-center mr-2 border rounded-lg bg-customGreenLight w-[3.4vw] h-[3.4vw] shrink-0 self-center">
        <img
          src={icon}
          alt={iconAlt}
          className="w-[1.7vw] h-[1.7vw] object-contain"
        />
      </div>
      <div className="flex flex-col flex-1">
        <h3 className="font-helveticaBold text-[0.9vw] xxl:text-[1vw] xxxl:text-[1.1vw] text-nowrap">
          {title}
        </h3>
        <p className="text-gray-600 text-[0.75vw] xxl:text-[0.82.5vw] xxxl:text-[0.90vw] tracking-tight line-clamp-2">
          {description}
        </p>
      </div>
    </div>
  );
};

export default FeatureCard;
